export default "﻿<div class=\"dateDialog w3-card\" data-dojo-attach-point=\"dateDialog\" style=\"display:none;\"></div>"